import { odata } from '../../conf';
import Actions from '../../odata/actions';

const actions = new Actions('customerServiceRating', 'customerServiceRatings');

const customActions = {
  async LOAD_customerServiceRatings({ commit, rootGetters }) {
    const data = await odata.o(rootGetters)
      .get('customerServiceRatings')
      .query({ $filter: 'IsDeleted eq false', $orderby: 'Created desc' });
    commit('SET_customerServiceRatings', data);
    return data;
  },
};

export default { ...actions, ...customActions };
